import React from 'react';
export default function TimelinePage({ setSt, notify }) {
  return (
    <div style={{maxWidth:640,margin:'0 auto',padding:'var(--sp4)',fontFamily:'var(--sans)'}}>
      <div style={{fontSize:28,fontWeight:300,color:'var(--ink)',marginBottom:8}}>
        timeline <span style={{color:'var(--t3)'}}>coming soon</span>
      </div>
      <div style={{fontSize:13,color:'var(--t3)',marginTop:8}}>this section is in progress.</div>
    </div>
  );
}
